import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../Modal";
import { showModal, hideModal } from "../../store/actions/modal";

interface SimpleModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  size?: string;
  showClose?: boolean;
}

let modalCounter = 0;

/**
 * SimpleModal - A wrapper around the Redux Modal component
 * that provides a simpler isOpen/onClose API for self-contained flows
 */
const SimpleModal: React.FC<SimpleModalProps> = ({
  isOpen,
  onClose,
  title = "",
  children,
  size = "md",
  showClose = true,
}) => {
  const dispatch = useDispatch();
  const modalNameRef = useRef(`simple-modal-${++modalCounter}`);
  const modalName = modalNameRef.current;
  const visibleModal = useSelector((state: any) => state.modal?.visibleModal);

  useEffect(() => {
    if (isOpen && visibleModal !== modalName) {
      dispatch(showModal(modalName));
    } else if (!isOpen && visibleModal === modalName) {
      dispatch(hideModal());
    }
  }, [isOpen, modalName, visibleModal, dispatch]);

  const handleClose = () => {
    dispatch(hideModal());
    // Small delay to ensure Redux state updates before calling parent onClose
    setTimeout(() => {
      onClose();
    }, 50);
  };

  return (
    <Modal
      name={modalName}
      title={title}
      onClose={handleClose}
      showClose={showClose}
    >
      {children}
    </Modal>
  );
};

export default SimpleModal;
